import { Stack } from "@mui/material";
import _ from "lodash";
import ClearRecurringButton from "./ClearButton";
import RecurringFrequency from "./Frequency";
import RecurringQuantity from "./Quantity";

const VademecumRecurringSettings = props => {
  return (
    <Stack spacing={3} direction={{ xs: "column", sm: "row" }}>
      <RecurringFrequency {...props} />
      <RecurringQuantity {...props} />
      <ClearRecurringButton {...props} />
    </Stack>
  );
};

const RecurringSettings = ({ wizardProps, ...props }) => {
  const prescriptionMethod = wizardProps.fullForm?.method;
  if (prescriptionMethod != "vademecum") return;

  return <VademecumRecurringSettings {...props} />;
};

export default RecurringSettings;